import React from "react"
import { Card, Heading, Hero, Section, Tile } from "react-bulma-components"
import smileTransparent from "../smile_transparent.svg"
import Socials from "./Socials"

const Home: React.FC = () => {
  return (
    <div>
      <header>
        <Hero color="primary" size="medium">
          <Hero.Header></Hero.Header>
          <Hero.Body className="has-text-centered">
            <Heading size={1}>
              <img
                className="large-image shake-image"
                src={smileTransparent}
                alt=""
              />
              <br />
              {/* <img className="inline-image" src="{smileTransparent}" /> */}
              Hey, I'm Beatso!
            </Heading>
            <Heading subtitle size={3}>
              <br />
              I'm learning full-stack web development,
              <br />
              with an interest in Minecraft and discord bots.
              <br />
              Here you can find some of the things I've made.
            </Heading>
          </Hero.Body>
        </Hero>
      </header>

      <Section>
        <Tile vertical kind="ancestor">
          <Tile>
            <Tile kind="parent">
              <Tile kind="child">
                <a href="https://github.com/Beatso/Picasso">
                  <Card>
                    <Card.Image
                      size="3by1"
                      src="/projectScreenshots/picasso.png"
                    />
                    <Card.Content>
                      <Heading>Picasso</Heading>
                      <Heading subtitle>
                        A discord bot to scale pixel art.
                      </Heading>
                    </Card.Content>
                  </Card>
                </a>
              </Tile>
            </Tile>
            <Tile kind="parent">
              <Tile kind="child">
                <a href="https://packupdater.netlify.app/">
                  <Card>
                    <Card.Image
                      size="3by1"
                      src="/projectScreenshots/packupdater.png"
                    />
                    <Card.Content>
                      <Heading>Pack Updater</Heading>
                      <Heading subtitle>
                        A web tool to update the pack_format of Minecraft
                        resource packs and data packs.
                      </Heading>
                    </Card.Content>
                  </Card>
                </a>
              </Tile>
            </Tile>
            <Tile kind="parent">
              <Tile kind="child">
                <a href="https://github.com/Beatso/BeatsosAdditions">
                  <Card>
                    <Card.Image
                      size="3by1"
                      src="/projectScreenshots/beatsosadditions.png"
                    />
                    <Card.Content>
                      <Heading>Beatso's Additions</Heading>
                      <Heading subtitle>
                        An upcoming Minecraft mod for the Fabric mod loader.
                      </Heading>
                    </Card.Content>
                  </Card>
                </a>
              </Tile>
            </Tile>
          </Tile>
        </Tile>

        <Tile kind="ancestor">
          <Tile vertical size={8}>
            <Tile kind="parent">
              <Tile kind="child">
                <a href="https://littleimprovementscustom.beatso1.repl.co/">
                  <Card>
                    <Card.Image size="3by1" src="/projectScreenshots/lic.png" />
                    <Card.Content>
                      <Heading>Little Improvements: Custom</Heading>
                      <Heading subtitle>
                        A Minecraft resource pack picker.
                      </Heading>
                    </Card.Content>
                  </Card>
                </a>
              </Tile>
            </Tile>
          </Tile>
          <Tile vertical size={4}>
            <Tile kind="parent">
              <Tile kind="child">
                <a href="https://www.planetminecraft.com/mod/simple-auto-clicker/">
                  <Card className="full-height">
                    <Card.Image
                      size="3by2"
                      src="/projectScreenshots/simpleautoclicker.png"
                    />
                    <Card.Content>
                      <Heading>Simple Auto Clicker</Heading>
                      <Heading subtitle>
                        A program written in AHK to click in a Minecraft window.
                      </Heading>
                    </Card.Content>
                  </Card>
                </a>
              </Tile>
            </Tile>
          </Tile>
        </Tile>

        <Tile vertical kind="ancestor">
          <Tile>
            <Tile kind="parent">
              <Tile kind="child">
                <a href="https://github.com/Beatso/Schubert">
                  <Card>
                    <Card.Image
                      size="3by1"
                      src="/projectScreenshots/schubert.png"
                    />
                    <Card.Content>
                      <Heading>Schubert</Heading>
                      <Heading subtitle>
                        A discord bot to give users a role when they are in a
                        voice channel.
                      </Heading>
                    </Card.Content>
                  </Card>
                </a>
              </Tile>
            </Tile>
            <Tile kind="parent">
              <Tile kind="child">
                <a href="https://fingermaps.net/">
                  <Card>
                    <Card.Image
                      size="3by1"
                      src="/projectScreenshots/fingermaps.png"
                    />
                    <Card.Content>
                      <Heading>FingerMaps</Heading>
                      <Heading subtitle>
                        The website for the Minecraft map making team,
                        FingerMaps.
                      </Heading>
                    </Card.Content>
                  </Card>
                </a>
              </Tile>
            </Tile>
            <Tile kind="parent">
              <Tile kind="child">
                <a href="/coming-soon">
                  <Card>
                    <Card.Image
                      size="3by1"
                      src="/projectScreenshots/muddysbundle.png"
                    />
                    <Card.Content>
                      <Heading>Muddy's Bundle</Heading>
                      <Heading subtitle>
                        A Minecraft resource pack picker made for Bold Muddy.
                      </Heading>
                    </Card.Content>
                  </Card>
                </a>
              </Tile>
            </Tile>
          </Tile>
          <Tile>
            <Tile kind="parent">
              <Tile kind="child">
                <a href="https://www.npmjs.com/package/scale-pixel-art">
                  <Card>
                    <Card.Image
                      size="3by1"
                      src="/projectScreenshots/scalepixelart.png"
                    />
                    <Card.Content>
                      <Heading>Scale Pixel Art</Heading>
                      <Heading subtitle>
                        An npm package to scale images with nearest neighbour
                        interpolation.
                      </Heading>
                    </Card.Content>
                  </Card>
                </a>
              </Tile>
            </Tile>
            <Tile kind="parent">
              <Tile kind="child">
                <a href="https://rpinfo.beatso.tk/">
                  <Card>
                    <Card.Image
                      size="3by1"
                      src="/projectScreenshots/rpinfo.png"
                    />
                    <Card.Content>
                      <Heading>Resource Pack Info</Heading>
                      <Heading subtitle>
                        A small wiki with useful info and tips for making
                        Minecraft resource packs.
                      </Heading>
                    </Card.Content>
                  </Card>
                </a>
              </Tile>
            </Tile>
            <Tile kind="parent">
              <Tile kind="child">
                <a href="https://beatso.github.io/reddit-spyglass/">
                  <Card>
                    <Card.Image
                      size="3by1"
                      src="/projectScreenshots/redditspyglass.png"
                    />
                    <Card.Content>
                      <Heading>Reddit Spyglass</Heading>
                      <Heading subtitle>
                        An npm package to translate text through many different
                        random languages, and then back into English.
                      </Heading>
                    </Card.Content>
                  </Card>
                </a>
              </Tile>
            </Tile>
            <Tile kind="parent">
              <Tile kind="child">
                <a href="https://github.com/Beatso/Pinn">
                  <Card>
                    <Card.Image
                      size="3by1"
                      src="/projectScreenshots/pinn.png"
                    />
                    <Card.Content>
                      <Heading>Pinn</Heading>
                      <Heading subtitle>
                        A discord bot to let anyone pin messages, even without
                        the manage messages permission.
                      </Heading>
                    </Card.Content>
                  </Card>
                </a>
              </Tile>
            </Tile>
          </Tile>
          <Tile>
            <Tile kind="parent">
              <Tile kind="child">
                <a href="https://beatso.github.io/InspiroQuote/">
                  <Card>
                    <Card.Image
                      size="3by1"
                      src="/projectScreenshots/inspiroquote.png"
                    />
                    <Card.Content>
                      <Heading>InspiroQuote</Heading>
                      <Heading subtitle>
                        A small website that uses the InspiroBot API to show
                        AI-generated inspirational quotes.
                      </Heading>
                    </Card.Content>
                  </Card>
                </a>
              </Tile>
            </Tile>
            <Tile kind="parent">
              <Tile kind="child">
                <a href="/coming-soon">
                  <Card>
                    <Card.Image
                      size="3by1"
                      src="/projectScreenshots/fentoimage.png"
                    />
                    <Card.Content>
                      <Heading>FEN to Image</Heading>
                      <Heading subtitle>
                        An online tool to convert many FEN strings (used in
                        chess) to chessboard images.
                      </Heading>
                    </Card.Content>
                  </Card>
                </a>
              </Tile>
            </Tile>
            <Tile kind="parent">
              <Tile kind="child">
                <a href="https://www.npmjs.com/package/translate-nonsense">
                  <Card>
                    <Card.Image
                      size="3by1"
                      src="/projectScreenshots/translatenonsense.png"
                    />
                    <Card.Content>
                      <Heading>Translate Nonsense</Heading>
                      <Heading subtitle>
                        An npm package to translate text through many different
                        random languages, and then back into English.
                      </Heading>
                    </Card.Content>
                  </Card>
                </a>
              </Tile>
            </Tile>
          </Tile>
        </Tile>
      </Section>

      <Socials></Socials>
    </div>
  )
}

export default Home
